/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CaslRulesDto } from '../models/CaslRulesDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CaslService {

    /**
     * @returns CaslRulesDto
     * @throws ApiError
     */
    public static getRules(): CancelablePromise<CaslRulesDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/casl',
        });
    }

}
